import { render, staticRenderFns } from "./VisualizarImovelMonitoramentoAgricolaParaguai.vue?vue&type=template&id=4c7833cc&lang=pug"
import script from "./VisualizarImovelMonitoramentoAgricolaParaguai.vue?vue&type=script&lang=js"
export * from "./VisualizarImovelMonitoramentoAgricolaParaguai.vue?vue&type=script&lang=js"
import style0 from "./VisualizarImovelMonitoramentoAgricolaParaguai.vue?vue&type=style&index=0&id=4c7833cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports